/**
 * The question lifecycle, on roots only; parts inherit their root's status.
 * Mirrors public.is_question_status_transition_allowed.
 */
export enum QuestionStatus {
  Draft = 'draft',
  NeedsSolution = 'needs_solution',
  ReadyForEnrichment = 'ready_for_enrichment',
  AwaitingReview = 'awaiting_review',
  Published = 'published',
  Superseded = 'superseded',
  Retired = 'retired',
  Rejected = 'rejected',
}
